import React, { useEffect, useState } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import moment from "moment";
import DailyEarthquakeReportStatusForm from "./DailyEarthquakeReportStatusForm";
import "../ReportEnhanced.css";
//import DMSHeader from "../../DMSHeader/DMSHeader";

const DailyEarthquakeReportStatus = () => {
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  useEffect(() => {
    GridStack.init();
  }, []);
  const fireWaveReportStatusfile = `DailyFireWaveReportStatus_${selectedDate}`;
  console.log("filename in reprotstatus=====", fireWaveReportStatusfile);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title="Earthquake Daily Report Status"
          fileName={`DailyEarthquakeReportStatus`}
          increaseHeaderHeight={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 10,
      id: 2,
      component: (
        <DailyEarthquakeReportStatusForm
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      ),
    },
  ];

  return (
    <div className="report-enhanced-wrapper">
      <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
        <GridItem layoutData={layoutData} />
      </div>
    </div>
  );
};

export default DailyEarthquakeReportStatus;
